import { connect } from "react-redux";

import {
  addClientLocation,
  getClientList,
  getClientLocation,
  getClientShortList,
  updateClientLocation,
  createClient,
} from "../../ClientsNew/clientsActions";
import { getOfficesShortList } from "../../Offices/officesActions";
import {
  createOrgLocation,
  getOrganizationLocations,
} from "../../Organization/OrganizationActions";
import {
  getOrganizationMembersList,
  getOrganizationMembersShortList,
} from "../../Projects/projectsActions";
import {
  createJobRequest,
  getWorkOrderShortList,
} from "../../WorkOrderNew/workOrderActions";
import { addTaskLocation, createTask, getTaskType } from "../tasksActions";
import { createJobDocument } from "../../Jobs/jobsActions";
// Component
import CreateJob from "./CreateJob";
import CreateJobNew from "./CreateJobNew";

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  orgMembersList: state.project.orgMembersList,
  orgMembersShortList: state.project.orgMembersShortList,
  officesShortList: state.office.officesShortList,
  memberShortListIsLoading: state.project.memberShortListIsLoading,
  isLoading: state.task.isLoading,
  addTaskLocationLoading: state.task.addTaskLocationLoading,
  createdTaskInfo: state.task.createdTaskInfo,
  locationsList: state.task.locationsList,
  createdTaskLocationInfo: state.task.createdTaskLocationInfo,
  taskTypeIsLoading: state.task.taskTypeIsLoading,
  taskTypeList: state.task.taskTypeList,
  //workordershort
  workOrderShortList: state.workorder.workOrderShortList,
  //Customer Location
  clientLocationList: state.client.clientLocationList,
  getclientLocalMapLoading: state.client.getclientLocalMapLoading,
  addOrUpdateclientLocalMapLoading:
    state.client.addOrUpdateclientLocalMapLoading,
  createdClientLocationInfo: state.client.createdClientLocationInfo,
  //Organization Location
  organizationLocationList: state.organization.organizationLocationList,
  getOrganizationLocationLoading:
    state.organization.getOrganizationLocationLoading,
  addOrgLocationLoading: state.organization.addOrgLocationLoading,
  createdOrgLocationInfo: state.organization.createdOrgLocationInfo,
  //job
  createdJob: state.workorder.createdJob,
  createdJobId: state.workorder.createdJobId,
  createOrUpdateJobIsLoading: state.workorder.createOrUpdateJobIsLoading,
  isJobLimitFull: state.workorder.isJobLimitFull,
  //job documents
  documentLoading: state.jobs.isLoadingJobDocuments,
  documentDone: state.jobs.jobDocumentDone,
  documentError: state.jobs.error,

  //client
  createdClientId: state.client.createdClientId,
  createdClientInfo: state.client.createdClientInfo,
  clientShortList: state.client.clientShortList,
  isClientLoading: state.client.isLoading,

});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getOrganizationMembersList: params =>
    dispatch(getOrganizationMembersList(params)),
  getOrganizationMembersShortList: params =>
    dispatch(getOrganizationMembersShortList(params)),
  createTask: params => dispatch(createTask(params)),
  addTaskLocation: params => dispatch(addTaskLocation(params)),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  getTaskType: params => dispatch(getTaskType(params)),
  getWorkOrderShortList: params => dispatch(getWorkOrderShortList(params)),
  getClientLocation: details => dispatch(getClientLocation({ ...details })),
  getOrganizationLocations: details =>
    dispatch(getOrganizationLocations({ ...details })),
  createOrgLocation: details => dispatch(createOrgLocation({ ...details })),
  addClientLocation: details => dispatch(addClientLocation({ ...details })),
  updateClientLocation: details =>
    dispatch(updateClientLocation({ ...details })),
  createJobRequest: details => dispatch(createJobRequest({ ...details })),
  createJobDocument: details => dispatch(createJobDocument(details)),
  createClient: details => dispatch(createClient({ ...details })),
  getClientShortList: details => dispatch(getClientShortList({ ...details })),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(CreateJobNew);
